<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useSettingsStore } from '@/stores/settings'
import api from '@/services/api'

export default {
  name: 'App',
  setup() {

    const settingsStore = useSettingsStore()

    const urlBase64ToUint8Array = (base64String) => {

      const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
      const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
      const rawData = window.atob(base64)
      const outputArray = new Uint8Array(rawData.length)
      
      for (let i = 0; i < rawData.length; ++i) {
      
        outputArray[i] = rawData.charCodeAt(i)
      }
      
      return outputArray
    }

    /*
    const requestPushPermission = async () => {
    
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) return
    
      try {

        const registration = await navigator.serviceWorker.register('/sw.js')
        const permission = await Notification.requestPermission()
        
        if (permission === 'granted') {

          const existing = await registration.pushManager.getSubscription()

          if (existing) {

            await existing.unsubscribe()
          }

          const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array('BCxvFJ8ywooVYPI1kOG8YVAzsNWJBi44HgR50q6IL9sBuwqpTzabOl4IF_hDe7RZaczD4lhpHcc4rd2_0l1VBOY')
          })
          
          await api.post('core/push-subscribe/', subscription)

          console.log("Subscription inviata con successo!")
        }
      } 
      catch (error) {
      
        console.error("Errore push:", error)
      }
    }
    */

    onMounted(async () => {

      await settingsStore.fetchSettings()
      //requestPushPermission()
    })

    return { settingsStore }
  }
}
</script>

<style>
body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  min-height: 100vh;
}
</style>


